<template xmlns="http://www.w3.org/1999/html">
    <div>
    <!-- Payment vue.js Component -->
    <div class="ibox">
    <div>
        <payments  :logged-user='loggedUser'
                   :item-type="itemType"
                    :can-see-customer="canSeeCustomer"
                   :show-payment-modal-earning="showPaymentModalEarning"
                   :currency='currency'
                   @modalOpened="modalOpened"
                   :booking-invoices='bookingInvoices'
                   :booking-payment-summary='bookingPaymentSummary'
                   :booking-nums='bookingNums'
                   :has-recurring='hasRecurring'
                   :company-has-default-payment-gateway="companyHasDefaultPaymentGateway"
                   :view-page="true"
                   :show-view-invoice-popup="showViewInvoicePopup">

        </payments>
        </div>
    </div>
    <div class="ibox">
            <field-worker-earnings
                v-if="!showPaymentModalEarning"
                :booking-id="bookingId"
                :item-type="itemType"
                :item-id="bookingId"
                merged-invoice-id= "0"
                :has-recurring="hasRecurring"
                :booking-nums='bookingNums'
            >
            </field-worker-earnings>
            </div>
    </div>
</template>

<script>


export default {
    name: "PaymentAndFieldworkerEarning",
    props:{
        loggedUser: {
            type:Object
        },
        currency: {
                type:Object
        },
        bookingInvoices: {
        },
        bookingPaymentSummary: {
            type:Object
        },
        bookingNums: {

        },
        itemType:null,
        bookingId:null,
        canSeeCustomer:null,
        hasRecurring:false,
        companyHasDefaultPaymentGateway:true,
        showViewInvoicePopup:0
    },

    data(){
      return {
          showPaymentModalEarning:false,
      }
    },
    computed:{
        isMobile() {
            return this.getWidth() <= 768;
        },
        // itemType() {
        //     if (this.itemTypeValue){
        //         return  this.itemTypeValue
        //     }
        //     else if (this.allObject.toEstimate){
        //         return 'estimate'
        //     }
        //     else if (this.allObject.toInvoice){
        //         return 'invoice'
        //     }
        //     else if (this.allObject.gift_card){
        //         return 'gift_card'
        //     }
        //     else if ((this.allObject.event || {}).booking_id){
        //         return 'booking'
        //     }
        //     else if ( ( (this.allObject.event || {}).inquiry_id ) || this.isInquiry){
        //         return 'inquiry'
        //     }
        //     else {
        //         return 'booking'
        //     }
        // },

    },
    methods:{
        getWidth() {
            let xWidth = null;
            if (window.screen != null)
                xWidth = window.screen.availWidth;

            if (window.innerWidth != null)
                xWidth = window.innerWidth;

            if (document.body != null)
                xWidth = document.body.clientWidth;

            return xWidth;
        },
        modalOpened(value){
            this.showPaymentModalEarning = value;
        }
    },
    mounted() {

    }
}
</script>
